export const generateRandomString = (length) => {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  const randomStringArray = new Array(length)

  let randomValues
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    randomValues = new Uint32Array(length)
    crypto.getRandomValues(randomValues)
  }

  for (let i = 0; i < length; i += 1) {
    const randomIndex = randomValues
      ? randomValues[i] % charactersLength
      : Math.floor(Math.random() * charactersLength)

    randomStringArray[i] = characters.charAt(randomIndex)
  }

  return randomStringArray.join('')
}
